import { render, staticRenderFns } from "./ComplianceIcon.vue?vue&type=template&id=595a8394"
import script from "./ComplianceIcon.vue?vue&type=script&lang=js"
export * from "./ComplianceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports